"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActualDateTime = useActualDateTime;

var _variant = require("@faedev/variant");

var _react = require("react");

var _useOnce = require("./useOnce");

function useActualDateTime(refresh) {
  const [date, setDate] = (0, _react.useState)(new Date());
  (0, _useOnce.useOnce)(() => {
    _variant.V.branch(refresh, {
      onLoad: () => undefined,
      periodic: periodic => {
        const multiplier = _variant.V.branch(periodic.unit, {
          seconds: () => 1000,
          minutes: () => 60 * 1000,
          hours: () => 60 * 60 * 1000
        });

        setInterval(() => {
          setDate(new Date());
        }, periodic.value * multiplier);
      }
    });
  });
  return date;
}
//# sourceMappingURL=useActualDateTime.js.map